import * as Yup from "yup";
import { t } from "i18next";

import { SUM_TOLERANCE, YIELD_MONTHS } from "./YieldConfigTypes";

// Validation schema for the Yield Configuration form.
//
// Per-field rules: yield per rai per year must be > 0; each monthly % is
// required and constrained to 0–100. The cross-field rule (the 12 monthly
// percentages must sum to 100) is enforced with an object-level test so submit
// is blocked until it holds; the form also surfaces a live running total for
// immediate feedback.
const monthlyShape = YIELD_MONTHS.reduce(
  (shape, month) => {
    shape[month.field] = Yup.number()
      .typeError(t("yieldConfig.validation.required"))
      .min(0, t("yieldConfig.validation.minZero"))
      .max(100, t("yieldConfig.validation.maxHundred"))
      .required(t("yieldConfig.validation.required"));
    return shape;
  },
  {} as Record<string, Yup.AnySchema>,
);

export const getYieldConfigValidationSchema = () =>
  Yup.object({
    yieldPerRaiPerYear: Yup.number()
      .typeError(t("yieldConfig.validation.avgRequired"))
      .moreThan(0, t("yieldConfig.validation.avgPositive"))
      .required(t("yieldConfig.validation.avgRequired")),
    ...monthlyShape,
  }).test(
    "monthly-sum-100",
    t("yieldConfig.validation.sumHundred"),
    (values: Record<string, unknown>) => {
      const total = YIELD_MONTHS.reduce(
        (sum, month) => sum + (Number(values?.[month.field]) || 0),
        0,
      );
      return Math.abs(total - 100) <= SUM_TOLERANCE;
    },
  );
